import SurveyCounter from './SurveyCounter'

export default SurveyCounter
